<!-- card 6 -->
<div
  class="w-full rounded border border-[#e0e6ed] bg-white p-5 shadow-[4px_6px_10px_-3px_#bfc9d4] dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none"
>
  <div class="text-[#515365] dark:text-white-light">
    <form class="space-y-5" [formGroup]="form">


      <!-- <div>
        <label for="id">ID:</label>
        <input id="id" type="text" placeholder="Enter ID" class="form-input" formControlName="id" />
        <form-error [form]="form" controlName="id" [validations]="MasterMerchantProductFormValidations.id"></form-error>
      </div> -->

      <div>
        <label>Category :</label>
        <ng-select
          [items]="categories"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Category"
          class="custom-multiselect w-full"
          formControlName="category_id"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="category_id"
          [validations]="MasterMerchantProductFormValidations.category_id"></form-error>
      </div>

      <div>
        <label>Merchant :</label>
        <ng-select
          [items]="merchants"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Merchant"
          class="custom-multiselect w-full"
          formControlName="merchant_code"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="merchant_code"
          [validations]="MasterMerchantProductFormValidations.merchant_code"></form-error>
      </div>

      <div>
        <label>Provider :</label>
        <ng-select
          [items]="providers"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Provider"
          class="custom-multiselect w-full"
          formControlName="provider_id"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="provider_id"
          [validations]="MasterMerchantProductFormValidations.provider_id"></form-error>
      </div>


      <div>
        <label>Product :</label>
        <ng-select
          [items]="products"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Product"
          class="custom-multiselect w-full"
          formControlName="product_code"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="product_code"
          [validations]="MasterMerchantProductFormValidations.product_code"></form-error>
      </div>


      <div>
        <label for="fee_merchant">Merchant Fee:</label>
        <input id="fee_merchant" type="number" placeholder="Enter Merchant Fee" class="form-input"
               formControlName="fee_merchant" />
        <form-error [form]="form" controlName="fee_merchant"
                    [validations]="MasterMerchantProductFormValidations.fee_merchant"></form-error>
      </div>

      <div>
        <label for="fee_provider">Provider Fee:</label>
        <input id="fee_provider" type="number" placeholder="Enter Provider Fee" class="form-input"
               formControlName="fee_provider" />
        <form-error [form]="form" controlName="fee_provider"
                    [validations]="MasterMerchantProductFormValidations.fee_provider"></form-error>
      </div>

      <div>
        <label for="fee">Fee:</label>
        <input id="fee" type="number" placeholder="Enter Fee" class="form-input" formControlName="fee" />
        <form-error [form]="form" controlName="fee"
                    [validations]="MasterMerchantProductFormValidations.fee"></form-error>
      </div>

      <div>
        <label for="percent_price">Percent Price:</label>
        <input id="percent_price" type="number" placeholder="Enter Percent Price" class="form-input"
               formControlName="percent_price" />
        <form-error [form]="form" controlName="percent_price"
                    [validations]="MasterMerchantProductFormValidations.percent_price"></form-error>
      </div>


      <button
        [disabled]="form.invalid"
        type="button"
        class="btn btn-success mt-4 w-full md:w-[180px]"
        (click)="saveData()"
      >
        <span
          *ngIf="loading"
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span>
        Submit
      </button>
    </form>
  </div>
</div>
